
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("C:/git/order-app-2/sentry.client.config.ts")
            }
          });